// extracted by mini-css-extract-plugin
export default {"hotel-logo-dropzone":"components-settings-my-hotel-logo-field-module__hotel-logo-dropzone","dropzone":"components-settings-my-hotel-logo-field-module__dropzone"};